"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "8",
    height: "8",
    viewBox: "0 0 8 8"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: props.fill,
    fillRule: "evenodd",
    points: "6.993 0 3.999 2.992 1.006 0 0 1.007 2.992 4.001 0 6.993 1.006 8 3.999 5.007 6.993 8 8 6.993 5.008 4.001 8 1.007"
  }));
};

exports["default"] = _default;